module.exports = __webpack_public_path__ + "static/tangled-7_ceramic-mixed-media-private-colection-ab8fa55f957ea0c196de85e85108a267.jpg";